/* IotOsPlanDetailsViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./IotOsPlanDetailsViewRenderer");
const PagingOsPlanDetailsFeed = require("./PagingOsPlanDetailsFeed");
const PagingOsPlanDeviceFeed = require("../../../../lmrbcomponents/deviceexplorer/views/device_grid_view/PagingDeviceFeed");
const LinksColumn = require("./column_renderers/links/LinksComponent");
const DeviceStatusColumn = require("./column_renderers/device_status/DeviceStatusComponent");
// const TargetFilesColumn = require("./column_renderers/target_files/TargetFilesComponent");
const Registrations = require("../../../../../RegistrationNamespaces");
// matches the PagingFeed default sort this view's feed is created with
const DEFAULT_SORT = {createdOn: 1};
class IoTOsPlanDetailsViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        MUF,
        steveIo,
        storageFactory,
        ValueMapEntity,
        OdmOsUpgradePlan,
        VendorApiConfig
    ) {
        super();
        // One DeviceUpgradeStatusesChanged listener per visible device_status grid cell (up to pageSize) is expected.
        this.setMaxListeners(0);
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;
        this._userSession = userSession;
        this._steveIo = steveIo;
        this._pagingRelatedFeed = undefined;
        this._plan = undefined;
        this._gridKey = "iot_plan_details_grid";
        this._isScheduled = undefined;
        this._validateWorkId = undefined;
        this._isCiscoEnabled = undefined;
        this._isVendorApiImageCheckEnabled = undefined;
        this._VendorApiConfigEntityDef = VendorApiConfig;
        this._osImageServerPrefsEntity = undefined;
        this._ValueMapEntity = ValueMapEntity;
        this._OdmOsUpgradePlan = OdmOsUpgradePlan;
        this._storageFactory = storageFactory;
        this._deviceFeedSystemQuery = {managementState: {$in: ["MANAGED"]}};

        this.columnConfig = {
            manufacturer: {
                label: "Vendor",
                width: 300,
                sortable: true,
                priority: 1,
            },
            model: {
                label: "SKU",
                width: 350,
                sortable: true,
                priority: 2,
            },
            name: {
                label: "Device",
                width: 250,
                sortable: true,
                priority: 3,
            },
            osName: {
                label: "Current OS",
                width: 350,
                sortable: true,
                priority: 4,
            },
            osVersion: {
                label: "Current OS Version",
                width: 200,
                sortable: true,
                priority: 5,
            },
            id: {
                label: "Upgrade Status",
                width: 150,
                sortable: false,
                priority: 6,
                context: {
                    gameEditor: this._gameEditor,
                    osPlanDetailsViewModel: this,
                },
                columnRendererComponent: DeviceStatusColumn,
            },

            // imageAssociations: {
            //     label: "Images",
            //     width: 300,
            //     sortable: false,
            //     priority: 6,
            //     entityColumn: true,
            //     isCombinedColumn: true,
            //     columnRendererComponent: TargetFilesColumn,
            //     context: {
            //         gameEditor: this._gameEditor,
            //         logger: this._logger,
            //         modalUserFeedback: this._modalUserFeedback,
            //         osImageCatalog: this._osImageCatalogEntity,
            //         osImage: this._osImageEntity,
            //         osPlanDetailsViewModel: this,
            //         osUpgradePrefs: this._osUpgradePrefs,
            //     },
            // },
            action: {
                label: "Action",
                sortable: false,
                priority: 8,
                width: 80,
                columnRendererComponent: LinksColumn,
                context: {
                    gameEditor: this._gameEditor,
                    logger: this._logger,
                    modalUserFeedback: this._modalUserFeedback,
                    osImageCatalog: this._osImageCatalogEntity,
                    osImage: this._osImageEntity,
                    osPlanDetailsViewModel: this,
                    osUpgradePrefs: this._osUpgradePrefs,
                },
                entityColumn: true,
                isCombinedColumn: true,
                isLockedRight: true,
            },
        };
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerPlanListeners() {
        this._plan.on(
            "DirtyStateChanged",
            (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this))
        );
        this._plan.on(
            "PendingPatchesChanged",
            (this._onPendingPatchesChanged = this._onPendingPatchesChanged.bind(this))
        );
        this._plan.on(
            "PristinePropertiesChanged",
            (this._onPristinePropertiesChanged = this._onPristinePropertiesChanged.bind(this))
        );
        this._plan.on(
            "DeviceUpgradeStatusesPropertyUpdated",
            (this._onDeviceUpgradeStatusesChanged = this._onDeviceUpgradeStatusesChanged.bind(this))
        );
    }

    _unregisterPlanListeners() {
        this._plan.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
        this._plan.removeListener("PendingPatchesChanged", this._onPendingPatchesChanged);
        this._plan.removeListener("PristinePropertiesChanged", this._onPristinePropertiesChanged);
        this._plan.removeListener(
            "DeviceUpgradeStatusesPropertyUpdated",
            this._onDeviceUpgradeStatusesChanged
        );
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get steveIo() {
        return this._steveIo;
    }

    getPlan() {
        return this._plan;
    }

    get plan() {
        return this.getPlan();
    }

    set plan(newPlan) {
        this._plan = newPlan;
        return true;
    }
    get gameEditorRootElement() {
        return this._gameEditor.renderer._rootElem;
    }

    /*** Game Editor ***/
    get gameEditor() {
        return this.getGameEditor();
    }

    getGameEditor() {
        return this._gameEditor;
    }

    shutdown() {
        this._unregisterListeners();
        this._unregisterPlanListeners();
        return this._renderer
            .shutdown()
            .then(() => {
                if (this._pagingRelatedFeed) {
                    return this._pagingRelatedFeed.shutdown();
                }
                return Promise.resolve();
            })
            .then(() => {
                if (this._pagingDeviceFeed) {
                    return this._pagingDeviceFeed.shutdown();
                }
                return Promise.resolve();
            })
            .then(() => {
                if (this._childViewRenderer) {
                    return this._childViewRenderer.shutdown();
                }
                return Promise.resolve();
            })
            .then(
                () => {
                    // constructor-injected deps
                    this._modalUserFeedback = undefined;
                    this._userSession = undefined;
                    this._steveIo = undefined;
                    this._logger = undefined;
                    this._gameEditor = undefined;
                    this._storageFactory = undefined;
                    this._osImageCatalogEntity = undefined;
                    this._osImageEntity = undefined;
                    this._osUpgradePrefs = undefined;
                    this._osImageServerPrefs = undefined;
                    this._VendorApiConfigEntityDef = undefined;
                    this._ValueMapEntity = undefined;
                    this._OdmOsUpgradePlan = undefined;

                    // owned components / feeds
                    this._renderer = undefined;
                    this._pagingRelatedFeed = undefined;
                    this._pagingDeviceFeed = undefined;
                    this._childViewRenderer = undefined;

                    // columnConfig contexts hold refs back to gameEditor/logger/this — must drop
                    this.columnConfig = undefined;

                    // model / runtime state
                    this._plan = undefined;
                    this._isScheduled = undefined;
                    this._isDirty = undefined;
                    this._validateWorkId = undefined;
                    this._deviceFeedSystemQuery = undefined;
                    this._osImageServerPrefsEntity = undefined;
                    this._isCiscoEnabled = undefined;
                    this._isVendorApiImageCheckEnabled = undefined;
                    this._osmOptionEntities = undefined;
                    this._vendorOsMap = undefined;
                    this._planExecutionEntity = undefined;

                    return Promise.resolve();
                },
                (err) => {
                    this._logger.warn(err, "IoTOsPlanDetailsViewComponent.shutdown() error.");
                }
            );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDirtyStateChanged(dirtyState) {
        if (!_.isNull(this._plan._pendingPatches)) {
            dirtyState = true;
            this._gameEditor.getTabCmpnt().setDirty(dirtyState);
        }

        this.emit("Dirty", dirtyState);

        let onBeforeUnloadFunc = () => {
            return this._modalUserFeedback
                .displayConfirmation("Would you like to Save or Discard your changes?", {
                    title: "Unsaved Changes",
                    confirmDetails: {
                        text: "Save",
                        type: "additive",
                    },
                    rejectDetails: {
                        text: "Discard",
                        type: "text",
                    },
                })
                .then(() => {
                    if (this.isPlanFormValid(true)) {
                        return this.savePlan().then(() => undefined); // it will not close the tab if it will have something in result
                    }
                })
                .catch((err) => {
                    if (err.userRejected) {
                        return Promise.resolve(this._plan.clearPendingPatches(true))
                            .then(() => this._modalUserFeedback.hideDisplayed())
                            .then(() => {
                                this._isDirty = false;
                                this._gameEditor.getTabCmpnt().setDirty(false);
                            })
                            .then(() => undefined);
                    } else {
                        console.error("Error in onBeforeUnloadFunc! Err:", err);
                    }
                });
        };
        if (this.isDirty()) {
            this._gameEditor.setOnBeforeUnload(onBeforeUnloadFunc);
        } else {
            this._gameEditor.clearOnBeforeUnload();
        }
    }

    _onPendingPatchesChanged() {
        // TODO - this is a quick hack because the Array ref adapter does a shutdown and complete rebuild every time you call setValue. the effect to the user is they lose focus in the proxy list if they stop typing longer than the debounce
        // this.emit('PolicyPropertiesChanged');
    }

    async _onPristinePropertiesChanged(pristineProperties, before) {
        if (this._plan.deviceCount !== pristineProperties.deviceCount) {
            this._plan.setProperty("deviceCount", pristineProperties.deviceCount);
        }
        try {
            if (pristineProperties.status !== before.status) {
                if (["CANCELED", "COMPLETE", "ERROR"].indexOf(pristineProperties.status) >= 0) {
                    await this.getPlanExecutionEntity();
                }
            }
        } catch (err) {
            this._logger.warn("PristinePropertiesChanged :: err :: " + err);
        } finally {
            this.emit("PlanPropertiesChanged", pristineProperties, before);
        }
    }

    _onDeviceUpgradeStatusesChanged() {
        this.emit("DeviceUpgradeStatusesChanged");
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _clearImageAssociationVeil(groupedValue) {
        if (groupedValue === "detectedSku") {
            return this._modalUserFeedback
                .displayConfirmation(
                    "Are you sure you want to change how devices are grouped? This will permanently delete all existing image associations?",
                    {
                        title: "Group Devices",
                        confirmDetails: {
                            text: "Confirm",
                            type: "destructive",
                        },
                        rejectDetails: {
                            text: "Cancel",
                            type: "text",
                        },
                    }
                )
                .then(() => {
                    return this._plan.clearAllImageAssociations();
                })
                .then(() => {
                    this.emit("Dirty", false);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        } else {
            return this._plan
                .ungroup()
                .then(() => {
                    this.emit("Dirty", false);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        }
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    isDirty() {
        return this._plan.isDirty();
    }

    get logger() {
        return this._logger;
    }
    get isScheduled() {
        return this._isScheduled;
    }

    get isOsUpgradeAutoCaptured() {
        return this._gameEditor.isOsUpgradeAutoCaptured;
    }

    get isOsTransferAutoCaptured() {
        return this._gameEditor.isOsTransferAutoCaptured;
    }

    set isScheduled(newValue) {
        this._isScheduled = newValue;
        return true;
    }

    // getOsUpgradeOptions() {
    //     this._OsUpgradeOptionsEntity
    //         .loadOsUpgradeOptions(this._gameEditor.activeOrgId)
    //         .then((optionEntities) => {
    //             this._osmOptionEntities = optionEntities;
    //         });
    // }
    getVendorOsMap() {
        this._ValueMapEntity.loadVendorOsMapEntity(this._gameEditor.activeOrgId).then((entity) => {
            this._vendorOsMap = entity;
            return entity;
        });
    }

    getPlanExecutionEntity() {
        return this._plan.loadRelatedExecution().then((entity) => {
            this._planExecutionEntity = entity;
            return Promise.resolve();
        });
    }

    async whenModelIsReady() {
        return Promise.resolve()
            .then(() => {
                return Promise.all([this.getVendorOsMap()]);
            })
            .then(() => this._gameEditor.whenPlanIsReady())
            .then(async () => {
                this._deviceFeedSystemQuery = {
                    $and: [
                        {
                            deviceRawCategory: "iot",
                        },
                    ],
                };

                this._plan = this.gameEditor.getPlan();

                this._registerPlanListeners();

                this._pagingRelatedFeed = await this._createFeed(this._plan);
                this._pagingDeviceFeed = await this._createDeviceFeed();
                const userAuthActions = _.get(this._userSession, "authorizedActions", []);
                this._userHasosmImageValidationOverride =
                    userAuthActions.indexOf("osmImageValidationOverride") >= 0;
                return this._VendorApiConfigEntityDef.loadVendorApiConfig(
                    this._gameEditor.activeOrgId
                );
            })
            .then((vendorApiConfig) => {
                this._isCiscoEnabled = _.get(
                    vendorApiConfig,
                    "properties.vendors.cisco.enabled",
                    false
                );
                return Promise.resolve();
            })
            .catch((err) => {
                this._logger.warn(err, "IoTOsPlanDetailsViewComponent.whenModelIsReady() error");
                this._modalUserFeedback.displayError({
                    errorMsg: "This plan cannot be opened.",
                    errorCode: "",
                });
                return Promise.reject(err);
            });
    }
    resetPlanProperties() {
        this._plan.clearPendingPatches();
        return Promise.resolve();
    }

    isPlanFormValid(rollbackInvalidData = false) {
        const plan = this._plan;
        const inputChanges = plan.getProperties();
        const oldData = plan.getPristineProperties();
        const inputDataName = inputChanges.name.trim();
        const isInputNameEmpty = inputDataName.length === 0;

        if (isInputNameEmpty && rollbackInvalidData === false) {
            throw {
                errorMsg: "Name cannot be left empty. Please enter a valid plan name.",
                errorCode: "SyntaxError",
                title: "Error",
            };
        } else if (isInputNameEmpty && rollbackInvalidData === true) {
            plan.setName(oldData.name.trim());
            return true;
        } else {
            plan.setName(inputDataName);
            return true;
        }
    }

    savePlan() {
        return Promise.resolve()
            .then(() => {
                //do nothing unless this guy is dirty
                if (this._plan.isDirty()) {
                    this.isPlanFormValid();
                    return this._plan.update();
                }
            })
            .then((entity) => {
                this._plan.clearPendingPatches();
                return Promise.resolve(entity);
            })
            .catch((err) => {
                this._logger.warn({error: err}, "IoTOsPlanDetailsViewComponent.savePlan() error.");
                if (err.errorCode === "NoPendingUpdates") {
                    this.emit("RefreshPlanDetails");
                    return Promise.reject();
                } else {
                    return this._modalUserFeedback.displayError(err);
                }
            });
    }

    _cancelScheduler() {
        return Promise.resolve()
            .then(() => {
                return this._plan.removePlanSchedule();
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "IoTOsPlanDetailsViewComponent._cancelScheduler() error."
                );
                return Promise.reject();
            });
    }

    _switchView(switchTo) {
        this._gameEditor.setActiveView(switchTo, [
            {
                value: {
                    fqn: Registrations.OS_PLAN_EDITOR_VIEW_DETAILS,
                    viewState: {plan: this._plan},
                },
                content: "Details",
                left: {
                    arrow: {
                        direction: "left",
                    },
                },
            },
        ]);
    }

    _cancelRemaining() {
        return Promise.resolve()
            .then(() => {
                return this._plan.cancelPlanWork(this._workId);
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "OsPlanResultsViewComponent._cancelRemaining() error."
                );
                return Promise.reject();
            });
    }

    onUserSorted(sortData) {
        let sort = {};
        [].concat(sortData).forEach((entry) => {
            if (!entry || !entry.sortColumn || !this.columnConfig[entry.sortColumn]) {
                return;
            }
            sort[entry.sortColumn] = entry.sort === "asc" ? 1 : -1;
        });
        if (_.isEmpty(sort)) {
            // clone: PagingFeed.setSort() keeps the reference it is given
            sort = _.clone(DEFAULT_SORT);
        }
        this._pagingRelatedFeed.setSort(sort);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/

    _createFeed(entity) {
        const odmOsPlanFeed = new PagingOsPlanDetailsFeed({
            feedKey: this._gridKey + "_feed",
            userSession: this._userSession,
            entityDef: entity,
            columnConfig: this.columnConfig,
            // default is 50, but setting to 100 means most lists wont need any paging
            // new speedups make larger page size viable for these lists
            pageSize: 100,
            filter: {},
        });

        return odmOsPlanFeed.whenFeedReady();
    }

    _createDeviceFeed() {
        const filterQuery = {
            $userQuery: {},
            $systemQuery: this._deviceFeedSystemQuery,
        };
        const pagingDeviceFeed = new PagingOsPlanDeviceFeed({
            activeOrgId: this._gameEditor.activeOrgId,
            entityDef: this._gameEditor.getDeviceEntity(),
            feedKey: this._gridKey + "_feed",
            columnConfig: undefined,
            pageSize: this._pageSize,
            sort: {name: 1},
            filter: filterQuery,
        });

        return pagingDeviceFeed.whenFeedReady();
    }
}

module.exports = IoTOsPlanDetailsViewComponent;

IoTOsPlanDetailsViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.io",
    "$teve.storageFactory",
    "$teve.entities.ValueMap",
    "$teve.entities.OdmOsUpgradePlan",
    "$teve.entities.VendorApiConfig",
];

IoTOsPlanDetailsViewComponent.$displayDetails = {
    type: "View",
    name: "IoT OS Plan Details",
    icon: "osmanager.edit_os_plan",
    shown: true,
    title: "Details",
    order: 1,
};
